const { defineMessages } = require('@sm/intl');

const COPY = defineMessages({
  BEST_VALUE: {
    id: 'PackageCta.BestValue',
    defaultMessage: 'BEST VALUE',
    desc: '[Type: Label][Vis.: high] - Default text for Package Ribbon',
  },
  SAVE_PERCENTAGE: {
    id: 'PackageCta.SavePercentage',
    defaultMessage: 'Save {percentage}% *',
    desc: '[Type: Label][Vis.: high] - Percentage of savings displayed in Package Ribbon',
  },
});

export default COPY;
